import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface IProps {
  open: boolean;
  handleOpen: () => void;
  alert_name: string | null;
  handleStopAlert: (alert_name: string) => void;
}

const StopAlertModal = ({
  open,
  handleOpen,
  alert_name,
  handleStopAlert,
}: IProps) => {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            fontFamily: "Lato, sans-serif",
            backgroundColor: "#0c1835",
            color: "#ebe93e",
          }}
        >
          {alert_name}
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: "#e8eaef" }}>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ fontFamily: "Lato, sans-serif", marginTop: "0.75rem" }}
          >
            Are you sure that you wish to stop this alert? This action will
            completely remove the alert.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: "#e8eaef" }}>
          <Button
            sx={{
              color: "#445581",
              fontWeight: "bold",
              fontFamily: "Lato, sans-serif",
            }}
            onClick={handleOpen}
          >
            Cancel
          </Button>
          <Button
            sx={{
              color: "#e70a16",
              fontWeight: "bold",
              fontFamily: "Lato, sans-serif",
            }}
            onClick={() => {
              if (alert_name) {
                handleStopAlert(alert_name);
                handleOpen();
              }
            }}
          >
            Stop Alert
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default StopAlertModal;
